export const ENLIGHTEN_SUPPORT_URL =
  'https://enphase.com/en-us/support/solar-professionals/software?modal-content=support-regions?m=mgr';
export const ENSTORE_URL = 'https://store.enphase.com/storefront/';
export const SGIP_OVERVIEW_HO = "https://enphase.com/en-us/sgip-overview";
export const SGIP_OVERVIEW_INSTALLER =
  "https://enphase.com/en-us/sgip-installer-page";
export const PRIVACY_POLICY_URL = 'https://www4.enphase.com/en-us/legal/privacy-policy'
//Dummy commit to test the build 